import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import querystring from 'query-string';

export default function deletePromotion(params) {
    const { baseUrl, brandId, country, language, promotionCode, uberToken, clientId, clientSecret, langId, additionalHeaders = {} } = params;

    invariant(baseUrl, 'baseUrl is a required param of deletePromotion()');
    invariant(brandId, 'brandId is a required param of deletePromotion()');
    invariant(country, 'country is a required param of deletePromotion()');
    invariant(language, 'language is a required param of deletePromotion()');
    invariant(promotionCode, 'promotionCode is a required param of deletePromotion()');
    invariant(uberToken, 'uberToken is a required param of deletePromotion()');
    invariant(clientId, 'clientId is a required param of deletePromotion()');

    const headers = { 'Content-Type': 'application/json', ...additionalHeaders };
    const query = querystring.stringify({ langId });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart/@self/assigned_promotion_code/${encodeURIComponent(promotionCode)}${
        query ? `?${query}` : ''
    }`;

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'DELETE' }), uberToken, clientId, clientSecret),
        'deletePromotion',
    );
}
